import axios from "axios";
import { db } from '@/plugins/dexie'

export const OK = 200
export const CREATED = 201
export const INTERNAL_SERVER_ERROR = 500
export const UNPROCESSABLE_ENTITY = 422
export const UNAUTHORIZED = 401
export const FORBIDDEN = 403
export const NOTFOUND = 404
export const CSRF_ERROR = 419

export const AGREEMENT_STATUS_UNAGREEMENT = 1
export const AGREEMENT_STATUS_AGREEMENT = 2

export const SAVE_STORE_SUMMARY = 'summary'
export const SAVE_STORE_GRAPH = 'graph'

// 指定された時間のタイミングで、indexedDBを更新する
export const REFRESH_HOURS = 5;

export const DATA_TYPES = {
    SALES : 'sales',
    CUSTOMER : 'customerCount',
    UNIT_PRICE : 'customerUnitPrice',
    ROTATION : 'customerRotation',
    ORDER : 'orderAverage',
    STAY : 'stayAverage',
    TAKEOUT : 'takeoutRatio',
    PAYMENT : 'paymentTypeRatio',
    GENDER : 'genderRatio',
}

export async function sendGetParallelApi(apis) {
    let requestList = [];
    apis.forEach(function(api){
        requestList.push(axios.get(api.url, {params: api.params})
            .then(response =>{
                api.callback(response);
            }));
    })
    await Promise.all(requestList);
}
export async function sendPostParallelApi(apis) {
    let requestList = [];
    apis.forEach(function(api){
        requestList.push(axios.post(api.url, {params: api.params})
            .then(response =>{
                api.callback(response);
            }));
    })
    await Promise.all(requestList);
}
export async function sendPutParallelApi(apis) {
    let requestList = [];
    apis.forEach(function(api){
        requestList.push(axios.put(api.url, api.params)
            .then(response =>{
                api.callback(response);
            }));
    })
    await Promise.all(requestList);
}

export function checkResponse(response) {
    const result = response.data?.result || 0;
    const data = response.data?.data || null;
    return result === true && data !== null;
}

// ストアに保存
export async function saveToStore (saveStore, data) {
    try {
        let store = selectDB(saveStore);
        // 保存実行（既にデータがある場合は更新、なければ新規追加）
        // store = db.graph or db.summary
        await store.put(data)
    } catch (error) {
        const status =
            `failed - data put to ${this.saveStore} :: from:${this.save.from} - to:${this.save.to}, store_id:${this.save.store_id}, type:${this.save.type}:: ${error}`
        console.error(status)
    }
}
// ストア検索
export async function searchStore (saveStore, filter, callback = null) {
    let store = selectDB(saveStore);
    let results =
        await store
            .where(filter)
            .first()
    if (results !== undefined) {
        // 該当データありの場合
        let dataset = [results]
        let datasetDetails = results.details
        if(callback) {
            return callback({
                'header' : dataset,
                'data' : datasetDetails,
            })
        }
    } else {
        return false;
    }
}
// データ全削除
export async function clearData (saveStore) {
    let store = selectDB(saveStore);
    // データ全削除
    await store.clear()
}
function selectDB(saveStore) {
    if (saveStore === SAVE_STORE_SUMMARY) {
        return db.summary
    } else {
        return db.graph
    }
}
export async function checkDeadline(saveStore, filter, callback) {
    let store = selectDB(saveStore)
    let results =
         await store
            .where(filter)
            .first()
    let status = false
    let deadline = false
    if (results !== undefined) {
        // 該当データありの場合
        let dataset = [results]
        // 日付がN日過ぎてたら？何時を過ぎてたら？Summaryを更新する
        let now = new Date();
        now.setHours(now.getHours() - REFRESH_HOURS)
        now.setMinutes(0)
        now.setSeconds(0)
        now.setHours(REFRESH_HOURS)
        let nowMilli = now.getMilliseconds()
        const data = dataset[0];
        // let datasetDetails = results.details
        deadline = (nowMilli > data.timestamp)
        status = true
    }
    callback({status: status, deadline: deadline})
}

// 画面遷移時の比較基準チェック用関数
export async function checkComparison(callback, store) {
    const url = '/comparison'
    await axios.get(url).then((r) => {
        const response = r.data.data
        if(store === undefined) {
            callback(response !== null)
        } else {
            callback(response !== null, store)
        }
    })
}